import { BasicInfoFields } from './BasicInfoFields';
import { InsuranceFields } from './InsuranceFields';
import { WorkPreferenceFields } from './WorkPreferenceFields';

export const PersonalDetailsFields = () => (
  <>
    <BasicInfoFields />
    <InsuranceFields />
    <WorkPreferenceFields />
  </>
);
